import {
  Box,
  Button,
  Card,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material';
import {
  ScreenError,
  ScreenWrap,
  SearchInput,
  SelectInput,
  SoloLoading,
} from '../../components';
import { Plus } from '@phosphor-icons/react';
import ClinicianRow from './ClinicianRow';
import { Link } from 'react-router';
import useModifiableParams from '../../hooks/use-modifiable-params';
import { Api } from '../../api';

export default function ClinicianListScreen() {
  const {
    getParams,
    setModifiedParams,
    tablePaginationProps,
    tableSortLabelProps,
  } = useModifiableParams();

  const params = getParams();

  const api = Api.User.useReadCollectionClinicians(params);

  if (api.error) return <ScreenError {...api} />;

  const clinicians = api.data?.member;

  return (
    <ScreenWrap>
      <Stack spacing={3} alignItems="stretch">
        <Stack direction="row" justifyContent="space-between">
          <Typography variant="h4" component="h1">
            Clinicians
          </Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="end"
          spacing={2}
          sx={{ width: '100%' }}
        >
          <Box minWidth={568}>
            <SearchInput
              label="Search"
              value={params.search || ''}
              onChange={(e) =>
                setModifiedParams({ search: e.target.value, page: '1' })
              }
              placeholder="Search by name"
            />
          </Box>
          <SelectInput
            label="Type"
            labelId="type"
            value={params['clinicianProfile.type'] || ''}
            onChange={(value) =>
              setModifiedParams({ 'clinicianProfile.type': value, page: '1' })
            }
            options={[
              { label: 'All', value: '' },
              { label: 'Coach', value: 'coach' },
              { label: 'Physician', value: 'physician' },
              { label: 'Founder', value: 'founder' },
            ]}
          />
          <Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Plus />}
              component={Link}
              to="/clinicians/new"
            >
              Create
            </Button>
          </Box>
        </Stack>

        <Stack spacing={2}>
          <Card>
            {clinicians ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <TableSortLabel {...tableSortLabelProps('name')}>
                          Name
                        </TableSortLabel>
                      </TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell align="center">Assigned Users</TableCell>
                      <TableCell align="center">Appointments</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {clinicians.map((clinician) => (
                      <ClinicianRow
                        key={clinician['@id']}
                        clinician={clinician}
                      />
                    ))}
                  </TableBody>
                  <TableFooter
                    sx={{
                      borderTop: '1px solid rgba(224, 224, 224, 1)',
                    }}
                  >
                    <TableRow>
                      <TablePagination
                        {...tablePaginationProps({
                          totalItems: api.data?.totalItems ?? 0,
                          rowsPerPage: 10,
                        })}
                        count={api.data?.totalItems ?? 0}
                        colSpan={5}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </TableContainer>
            ) : (
              <SoloLoading />
            )}
          </Card>
        </Stack>
      </Stack>
    </ScreenWrap>
  );
}
